import BaseCommand from "@/models/api/commands/BaseCommand";

export class ResetOrderItemCommand extends BaseCommand {
  CommandName = "ResetOrderItem";
  Command: unknown;
  constructor(sessionId: string, operationId: string, orderItemId: string, keepOrderItemFees: boolean) {
    super(sessionId, operationId);
    this.Command = { OrderItemId: orderItemId, KeepOrderItemFees: keepOrderItemFees };
  }
}
